import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { useFormik } from "formik";
import { connect } from "react-redux";
import ThankYou from "../../components/idp-medicine/thankYou";
import Controler from "../common/control"
import {getIdpData} from '../../../store/slices/idp/index'
import {
  postMedicalCommonApp,
  getMedicalIdpStatus,
  getMedicalFormStatus,
  getMedicalDegree,
  postMedicalDegree,
  getMedicalExam,
  postMedicalExam,
  getMedicalSpecialization,
  postMedicalSpecialization,
  getMedicalCoaching,
  clearMedicalCoachingResponse,
  postMedicalCoaching,
  getMedicalCoachingLocation,
  clearMedicalCoachingLocationResponse,
  postMedicalCoachingLocation,
  getMedicalCoachingList,
  postMedicalCoachingList,

  getMedicalCoachingMode,

  getMedicalPreferLocation,
  postMedicalPreferLocation,
  getMedicalPreferCollege,
  postMedicalPreferCollege,
  getMedicalOtherSpecialization,
  postMedicalOtherSpecialization,
  getMedicalTopColleges,
  postMedicalTopColleges,
  getMedicalProducts,
  postMedicalProducts,
  getMedicalProductsOneToOne,
  postMedicalProductsOneToOne,
  getMedicalProductsEnrollment,
  postMedicalProductsEnrollment,
  postMedicalLeadCreate,
  postMedicalFormSubmit,
} from "../../../store/slices/medical/form";
import {
  DEGREE,
  PREFERED_LOCATION,
  PREFERED_COLLEGE,
  FREE_COUNSELLING,
  ONE_TO_ONE_COUNSELLING,
} from "../../../client/constants/medical";
import { fetchUser } from "../../../store/slices/user/index";
import Loader from "../common/loader";

const MedicineForm = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [destination, setDestination] = useState(null);
  const [degreeTarget, setDegreeTarget] = useState(null);
  const [coachingList, setCoachingList] = useState(null)
  const [preferLocation, setPreferLocation] = useState(null);
  const [freeCounselling, setFreeCounselling] = useState(null);
  const [buyCounselling, setBuyCounselling] = useState(null);
  
  const [preferCollege, setPreferCollege] = useState(null);
  const [preferCollegeOnload, setPreferCollegeOnload] = useState(false)
  const [setvice, setSetvice] = useState(null);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [idpData, setIdpData] = useState({});

  const [coachingMode, setCoachingMode] = useState(null);

  useEffect(() => {
    props.dispatch(fetchUser());
  }, []);

  useEffect(() => {
    if (isFormSubmit == true) {
      setTimeout(() => {
        window.location.href = destination;
      }, 5000);
    }
  }, [isFormSubmit]);

  useEffect(() => {
    setFreeCounselling(props.productData?.pipeline_status);
    setBuyCounselling(props.productOneToOneData?.pipeline_status);
  }, [
    props.productData || props.productOneToOneData,
    props.productEnrollmentData,
  ]);

  useEffect(()=>{
    setCoachingList(props.coachingListData?.coaching_data)
  },[props.coachingListData?.coaching_data])

  useEffect(() => {
    let desti = window?.location?.search?.replace("?destination=", "");
    setDestination(desti);
    if (props.user) {
      props.dispatch(getIdpData({uid: props.user?.data?.id,idp:1}))
    }
  }, [props.user]);

  useEffect(()=>{
    if(props.getIdpData?.idp_form_id){
      props.dispatch(getMedicalFormStatus({ uid: props.user?.data?.id,idp_form_id:props.getIdpData?.idp_form_id }));
      props.dispatch(getMedicalIdpStatus({ uid: props.user?.data?.id,idp_form_id:props.getIdpData?.idp_form_id}));
      props.dispatch(postMedicalCommonApp({ uid: props.user?.data?.id,idp_form_id:props.getIdpData?.idp_form_id}));
      props.dispatch(getMedicalDegree({ uid: props.user?.data?.id,idp_form_id:props.getIdpData?.idp_form_id}));
      // props.dispatch(getMedicalCoachingList({ uid: props.user?.data?.id }));

      props.dispatch(getMedicalCoachingMode({ uid: props.user?.data?.id,idp_form_id:props.getIdpData?.idp_form_id}))
      
      props.dispatch(getMedicalPreferLocation({ uid: props.user?.data?.id ,idp_form_id:props.getIdpData?.idp_form_id}));
      props.dispatch(
        getMedicalPreferCollege({
          uid: props.user?.data?.id,
          location_type: preferLocation,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      props.dispatch(
        getMedicalOtherSpecialization({ uid: props.user?.data?.id ,idp_form_id:props.getIdpData?.idp_form_id})
      );
      props.dispatch(
        getMedicalProducts({ uid: props.user?.data?.id, product_id: 533711 ,idp_form_id:props.getIdpData?.idp_form_id})
      );
      props.dispatch(
        getMedicalProductsOneToOne({
          uid: props.user?.data?.id,
          product_id: 119929,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      props.dispatch(
        getMedicalProductsEnrollment({
          uid: props.user?.data?.id,
          product_id: 533710,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      props.dispatch(getMedicalCoachingLocation({uid: props.user?.data?.id ,idp_form_id:props.getIdpData?.idp_form_id}))
    }
  },[props.getIdpData?.idp_form_id])

  useEffect(()=>{
    if(!!props.coachingModeData?.coaching_mode?.length){
      let obj = props.coachingModeData?.coaching_mode.find(item => item.selected)
      if(obj){
        props.dispatch(getMedicalCoaching({ uid: props.user?.data?.id, mode:obj.id, idp_form_id:props.getIdpData?.idp_form_id }));
      }
    }
  },[props.coachingModeData])

  const gotToHomePage = window.location?.origin;
  useEffect(() => {
    if (props?.isUser?.user_error == "User Not Authenticated" && !!destination)
      window.location.href = destination;
    else if (
      props?.isUser?.user_error == "User Not Authenticated" &&
      !destination
    )
      window.location.href = gotToHomePage;
    else if (!!props?.isUser?.user && !destination)
      window.location.href = gotToHomePage;
  }, [props?.isUser]);
  
  useEffect(()=>{
    if(props?.idpStatusData?.idp_status != 0 && !!destination) window.location.href = destination;
  },[props?.idpStatusData?.idp_status])


  const [isCollegeData, setIsCollegeData] = useState(true)

  useEffect(() => {
      let exams = [];
      let specilizationArr = [];
      let specilizationSeletArr = [];
      let otherSspecilizationArr = [];
      let otherSpecilizationSeletArr = [];
      
      if(props?.specializationsData?.status == 'success' && props?.examData?.status == 'success') setIsLoading(false)

      props.examData?.exams?.filter((item) => {
        item.status == 1 && exams.push(`${item.id}`);
      });
      props.specializationsData?.specializations?.filter((item, ind) => {
        if (ind < 8) {
          if (item.status == 1) specilizationArr.push(`${item.id}`);
        }
        if (ind > 7) {
          if (item.status == 1) specilizationSeletArr.push(item);
        }
      });
      props.otherSpecializationData?.branches.filter((item, ind) => {
        if (ind < 8) {
          if (item.status == 1) otherSspecilizationArr.push(`${item.id}`);
        }
        if (ind > 7) {
          if (item.status == 1) otherSpecilizationSeletArr.push(item);
        }
      });

      let topPrivateArray = [];
      props.topCollegesData?.colleges?.filter((item, ind) => {
        if (item.status == 1) topPrivateArray.push(`${item.id}`);
      });
      let preferedCollegeArray = [];
      props.preferedCollegeData?.preferred_institute?.map((item, ind) => {
        preferedCollegeArray.push(`${item}`);
      });

      let preferedCoachingSelected = []
      props?.coachingListData?.coaching_data?.map(item =>{
        if(item.status == 1) preferedCoachingSelected.push(`${item.id}`)
      })

      let coachingMode = props.coachingModeData?.coaching_mode?.find(item => item?.selected)

      let selectedCoachingList = []
      props.coachingData?.coaching?.map((item, ind) =>{
        if(item.selected) selectedCoachingList.push(`${item.id}`)
      })

      let selectedCoachingLocation = []
      props.coachingLocation?.value?.map(item =>{
        if(item.selected) selectedCoachingLocation.push(`${item.id}`)
      })
      // props.coachingData?.coaching
      // console.log(props.coachingData?.coaching,'selectedCoachingLocation',selectedCoachingLocation)
      setIdpData({
        degree: !!props.degreeData?.degree ? degreeTarget : 0,
        target_exam: exams || [],
        specializations: specilizationArr || [],
        specializations_select: specilizationSeletArr || [],
        coaching_mode: coachingMode ? coachingMode?.id : '',
        // coaching_prefer: !!props?.coachingListData?.coaching_data?.length ? preferedCoachingSelected : [],
        coaching_prefer: !!props.coachingData?.coaching?.length ? selectedCoachingList : [],
        coaching_location: selectedCoachingLocation?.length ? selectedCoachingLocation : [],
        prefered_location: `${preferLocation}` || "",
        prefered_college: preferedCollegeArray || "",
        free_counselling: props.productData?.pipeline_status != null ? `${props.productData?.pipeline_status}` : "",
        buy_counselling: props.productOneToOneData?.pipeline_status != null ? `${props.productOneToOneData?.pipeline_status}` : "",
        enrollment: props.productEnrollmentData?.pipeline_status != null ? `${props.productEnrollmentData?.pipeline_status}` : 'null',
        other_specializations: otherSspecilizationArr || [],
        other_specializations_select: otherSpecilizationSeletArr || [],
        top_private_college: !!topPrivateArray?.length ? topPrivateArray : [],
      });

      if(props.examData?.exams && props.specializationsData){
        setIsLoading(false)
      }
      
  }, [
    props.degreeData,
    props.examData?.exams,
    props.specializationsData,
    props.coachingData,
    props.locationData,
    props?.coachingListData,
    props.preferedCollegeData,
    props.otherSpecializationData,
    props.topCollegesData,
    props.productData,
    props.productOneToOneData,
    props.productEnrollmentData,
    props.coachingData?.coaching,
    props.coachingModeData?.coaching_mode,
    props.coachingLocation
  ]);

  useEffect(() => {
    setPreferLocation(props.locationData?.preferred_location);
  }, [props.locationData?.preferred_location]);

  useEffect(() => {
    let result = []
    props.preferedCollegeData?.preferred_institute?.map(item =>{
      result.push(`${item}`)
    })
    
    setPreferCollege(result);
  }, [props.preferedCollegeData]);

  useEffect(() => {
    if (!!preferLocation) {
      props.dispatch(
        getMedicalTopColleges({
          uid: props.user?.data?.id,
          location_type: preferLocation,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
  }, [preferLocation]);

  useEffect(() => {
    setDegreeTarget(props.degreeData?.degree);
  }, [props.degreeData?.degree]);
  
  const validate = (values) =>{
    let error = {}
    // console.log(props.coachingModeData?.coaching_mode,'new valuesss???',props.coachingLocation?.value)
    // coaching_prefer
    if(!!DEGREE?.length && !values?.degree) error.degree = 'This Field is required'
    if(!!props.coachingModeData?.coaching_mode?.length && [1,3].includes(values?.degree) && !values?.coaching_mode) error.coaching_mode = 'This Field is required'
    if(!!props.coachingData?.coaching?.length && [1,3].includes(values?.degree) && !values?.coaching_prefer?.length) error.coaching_prefer = 'This Field is required'
    if(!!props.coachingLocation?.value?.length && [1,3].includes(values?.degree) && !values?.coaching_location?.length) error.coaching_location = 'This Field is required'
    if(!!FREE_COUNSELLING?.length && [1,3].includes(values?.degree) && !values?.free_counselling) error.free_counselling = 'This Field is required'
    if(!!ONE_TO_ONE_COUNSELLING?.length && [1,3].includes(values?.degree) && !values?.buy_counselling?.length) error.buy_counselling = 'This Field is required'
    
    if(!!props.examData?.exams?.length && !values?.target_exam?.length) error.target_exam = 'This Field is required'
    if(!!props.specializationsData?.specializations?.length && [2,3].includes(values?.degree) && !values?.specializations?.length) error.specializations = 'This Field is required'

    if(!!PREFERED_LOCATION?.length && !values?.prefered_location) error.prefered_location = 'This Field is required'
    if(!!PREFERED_COLLEGE?.length && [1,3].includes(values?.degree) && !values?.prefered_college?.length) error.prefered_college = 'This Field is required'
    // if(!!props.otherSpecializationData?.branches?.length && [1].includes(values?.degree) && !values?.other_specializations?.length) error.other_specializations = 'This Field is required'
    if(!!props.topCollegesData?.colleges?.length && [2,3].includes(values?.degree) && !values?.top_private_college?.length) error.top_private_college = 'This Field is required'
    return error
  }
  const {
    values,
    isValid,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: idpData,

    validateOnMount : true,
    validate:validate,

    //   validationSchema: signUpSchema,
    onSubmit: (values, action) => {
      let college_data
      [1,3]?.includes(degreeTarget) ? (college_data = values?.top_private_college) : (college_data = [])

      let exam_arr = []
      for(let item of values.target_exam){
        exam_arr.push(+item)
      }
      props.dispatch(
        postMedicalLeadCreate({
          uid: props.user?.data?.id,
          exams_list: exam_arr,
          college_list: college_data,
          destination: destination,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      props.dispatch(postMedicalFormSubmit({ uid: props.user?.data?.id ,idp_form_id:props.getIdpData?.idp_form_id}));
      // action.resetForm();
    },
  });
  // console.log('values form???',values)
  useEffect(()=>{
    if (props.formSubmitData?.status == "success") {
      setIsFormSubmit(true)
    };
  },[props.formSubmitData?.status])
  
  let coachingRef = useRef([])
  let [coachingId, setCoachingId] = useState(null)
  let [sepecilizationCheck, setSepecilizationCheck] = useState(null)
  const formData = (event, handleChange, type, data) => {
    setSetvice(type);
    let { value } = event.currentTarget;
    let { id } = event.target.dataset;
    let mode
    if (type == "degree") {
      setIsLoading(true)
      setDegreeTarget(+value);
      props.dispatch(
        postMedicalDegree({
          uid: props.user?.data?.id,
          degree_type: +value,
          action_type: 1,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      props.dispatch(
        getMedicalExam({ uid: props.user?.data?.id, degree_type: value, idp_form_id:props.getIdpData?.idp_form_id })
      );
      props.dispatch(
        getMedicalSpecialization({
          uid: props.user?.data?.id,
          degree_type: value,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );

      setTimeout(()=>{
        window.location.reload()
      },500)
    } else if (type == "coaching_mode") {
      setCoachingMode(+value)
      props.dispatch(clearMedicalCoachingResponse());
      props.dispatch(getMedicalCoaching({ uid: props.user?.data?.id, mode:value, idp_form_id:props.getIdpData?.idp_form_id}));
    } else if (type == "target_exam") {
      let status = 0;
      if (!!event.currentTarget?.checked) status = 1;
      else status = 0;

      props.dispatch(
        postMedicalExam({
          uid: props.user?.data?.id,
          selected_exams: +value,
          action: status,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "specializations") {
      let status = 0;
      if (!!event.currentTarget.checked) status = 1;
      else status = 0;
      
      !!event.currentTarget.checked && setSepecilizationCheck(event.currentTarget.value);

      props.dispatch(
        postMedicalSpecialization({
          uid: props.user?.data?.id,
          branch_ids: +value,
          action: status,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "coaching_prefer") {
      let status = 0;
      if (!!event.currentTarget?.checked) status = 1;
      else status = 0;
      if(value == '868' && !!event.target.checked){
        for (let i = 0; i < coachingRef.current.length; i++) {
          if(coachingRef.current[i]?.value != '868') coachingRef.current[i].checked = false;
        }
      } else if(value != '868'){
        for (let i = 0; i < coachingRef.current.length; i++) {
          if(coachingRef.current[i]?.value == '868') coachingRef.current[i].checked = false;
        }
      }
      setCoachingId(+value)
      setFieldValue('coaching_location', [])
      props.dispatch(
        postMedicalCoaching({
          uid: props.user?.data?.id,
          action: status,
          coaching_id: +value,
          mode: coachingMode,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "prefered_location") {
      setPreferLocation(+value);
      props.dispatch(
        postMedicalPreferLocation({
          uid: props.user?.data?.id,
          preffered_location: +value,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      // setIsCollegeData(false)
      // setTimeout(()=>{
      //   setIsCollegeData(true)  
      // },2000)
      setTimeout(()=>{
        window.location.reload()
      },500)
    } else if (type == "prefered_college") {
      setPreferCollegeOnload(true)
      let prefered_college_list = [];
      event.target.checked
        ? (prefered_college_list = [...preferCollege, value])
        : prefered_college_list.splice(preferCollege.indexOf(value), 1);
        
      setPreferCollege(prefered_college_list);

    } else if (type == "free_counselling") {
      setFreeCounselling(+value)
      let status = 0;
      if (event.target.id == "counselling-0") status = 1;
      else if (event.target.id == "counselling-1") status = 0;
      props.dispatch(
        postMedicalProducts({
          uid: props.user?.data?.id,
          product_id: +id,
          action: status,
          source_url: destination,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "buy_counselling") {
      setBuyCounselling(+value)
      let status = 0;
      if (event.target.id == "buy-counselling-0") status = 1;
      else if (event.target.id == "buy-counselling-1") status = 0;
      props.dispatch(
        postMedicalProductsOneToOne({
          uid: props.user?.data?.id,
          product_id: +id,
          action: status,
          source_url: destination,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "enrollment") {
      let status = 0;
      if (event.target.id == "enrollment-0") status = 1;
      else if (event.target.id == "enrollment-1") status = 0;
      props.dispatch(
        postMedicalProductsEnrollment({
          uid: props.user?.data?.id,
          product_id: +id,
          action: status,
          source_url: destination,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "other_specializations") {
      let status = 0;
      if (!!event.currentTarget.checked) status = 1;
      else status = 0;
      props.dispatch(
        postMedicalOtherSpecialization({
          uid: props.user?.data?.id,
          action: status,
          branch_ids: +value,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "top_private_college") {
      let status = 0;
      if (!!event.currentTarget.checked) status = 1;
      else status = 0;
      props.dispatch(
        postMedicalTopColleges({
          uid: props.user?.data?.id,
          action: status,
          college_id: +value,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if (type == "coaching_location") {
      let status = 0;
      if (!!event.currentTarget.checked) status = 1;
      else status = 0;
      props.dispatch(
        postMedicalCoachingLocation({
          uid: props.user?.data?.id,
          action: status,
          location: +value,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
    handleChange(event);
  };

  useEffect(() => {
    if(preferCollegeOnload){
      props.dispatch(
        postMedicalPreferCollege({
          uid: props.user?.data?.id,
          institute: values.prefered_college,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
  }, [values.prefered_college]);  

  useEffect(() => {
    if (!!props.degreeData?.degree) {
      props.dispatch(
        getMedicalExam({
          uid: props.user?.data?.id,
          degree_type: props.degreeData?.degree,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
      props.dispatch(
        getMedicalSpecialization({
          uid: props.user?.data?.id,
          degree_type: props.degreeData?.degree,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
  }, [props.degreeData?.degree]);

  const handleSpecializations = (obj, actionMeta) => {
    let isCheck = actionMeta.action === 'select-option' ? true : false
    let getID = actionMeta.action === 'select-option' ? actionMeta.option.id : actionMeta.removedValue.id
    let postData = {}
    postData.uid = props.user?.data?.id
    postData.entity = actionMeta.name

    if (actionMeta.action == "remove-value") {
      props.dispatch(
        postMedicalSpecialization({
          uid: props.user?.data?.id,
          branch_ids: actionMeta.removedValue.id,
          action: 0,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else {
      props.dispatch(
        postMedicalSpecialization({
          uid: props.user?.data?.id,
          branch_ids: obj[obj?.length - 1]?.id,
          action: 1,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
    
    let objID = actionMeta?.action === 'select-option' ? actionMeta?.option?.id : actionMeta?.removedValue?.id
    let tempArr = [...values[actionMeta.name]]
    let oldIDs = []
    if(isCheck){
      oldIDs = [...values[actionMeta.name],`${objID}`]
    } else {
      let index = values[actionMeta.name].indexOf(`${actionMeta.removedValue.id}`);
      tempArr?.splice(index,1);
      oldIDs = tempArr
    }
    setFieldValue(actionMeta.name, oldIDs);
  };
  // let status = 0;
  // if (!!event.currentTarget.checked) status = 1;
  // else status = 0;
  // props.dispatch(
  //   postMedicalCoachingLocation({
  //     uid: props.user?.data?.id,
  //     action: status,
  //     location: +value,
  //   })
  // );
  const handleCoaching = (obj, actionMeta, type) => {
    let action = actionMeta.action == "remove-value" ? 0 : 1
    let id = actionMeta.action == "remove-value" ? actionMeta?.removedValue?.id : actionMeta?.option?.id
    if(type === 'coaching_prefer'){
      props.dispatch(
        postMedicalCoaching({
          uid: props.user?.data?.id,
          action: action,
          coaching_id: +id,
          mode: coachingMode,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else if(type === 'coaching_location'){
      props.dispatch(
        postMedicalCoachingLocation({
          uid: props.user?.data?.id,
          action: action,
          location: +id,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
    
    let objID = actionMeta?.action === 'select-option' ? actionMeta?.option?.id : actionMeta?.removedValue?.id
    let tempArr = [...values[actionMeta.name]]

    let oldIDs = []
    if(!!action){
      oldIDs = [...values[actionMeta.name],`${objID}`]
    } else {
      let index = values[actionMeta.name].indexOf(`${actionMeta.removedValue.id}`);
      tempArr?.splice(index,1);
      oldIDs = tempArr
    }
    if(type === 'coaching_prefer'){
      setFieldValue("coaching_prefer", oldIDs);
    } else if(type === 'coaching_location'){
      setFieldValue("coaching_location", oldIDs);
    }
  };

  // console.log('form values???', values)

  // useEffect(()=>{
  //   if(!!props.coachingData?.coaching?.length){
  //       setSelected(hendleDefaultCheck(newData))
  //   }
  // },[values?.coaching_prefer])

  const handleOtherSpecializations = (obj, actionMeta) => {
    let isCheck = actionMeta.action === 'select-option' ? true : false
    let getID = actionMeta.action === 'select-option' ? actionMeta.option.id : actionMeta.removedValue.id
    let postData = {}
    postData.uid = props.user?.data?.id
    postData.entity = actionMeta.name

    if (actionMeta.action == "remove-value") {
      props.dispatch(
        postMedicalOtherSpecialization({
          uid: props.user?.data?.id,
          branch_ids: actionMeta.removedValue.id,
          action: 0,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    } else {
      props.dispatch(
        postMedicalOtherSpecialization({
          uid: props.user?.data?.id,
          branch_ids: obj[obj?.length - 1]?.id,
          action: 1,
          idp_form_id:props.getIdpData?.idp_form_id
        })
      );
    }
    let objID = actionMeta?.action === 'select-option' ? actionMeta?.option?.id : actionMeta?.removedValue?.id
    let tempArr = [...values[actionMeta.name]]
    let oldIDs = []
    if(isCheck){
      oldIDs = [...values[actionMeta.name],`${objID}`]
    } else {
      let index = values[actionMeta.name].indexOf(`${actionMeta.removedValue.id}`);
      tempArr?.splice(index,1);
      oldIDs = tempArr
    }
    setFieldValue(actionMeta.name, oldIDs);
  };

  const filterSpecilization = (arr) => {
    let ar = [];
    arr.filter((obj) => {
      if (obj.status == 1) ar.push(obj);
    });
    return ar;
  };
  const filterCoaching = (arr) => {
    let ar = [];
    arr.filter((obj) => {
      if (obj.selected) ar.push(obj);
    });
    return ar;
  };
  const otherFilterSpecilization = (arr) => {
    let ar = [];
    arr.filter((obj) => {
      if (obj.status == 1) ar.push(obj);
    });
    return ar;
  };
  
  const parseAndHandleChange = (value, setFieldValue, id) => {
    const parsed = parseInt(value.target.value)
    setFieldValue(id, parsed)
  }

  useEffect(()=>{
    let selectdMode = props.coachingModeData?.coaching_mode.find(item => item.selected)
    selectdMode?.selected ? setCoachingMode(+selectdMode?.id) : setCoachingMode(null)
    // console.log('props.coachingData',props.coachingData)
  },[props.coachingModeData])

  useEffect(()=>{
    if(props.postcoachingData){
      props.dispatch(clearMedicalCoachingLocationResponse())
      props.dispatch(getMedicalCoachingLocation({uid: props.user?.data?.id, idp_form_id:props.getIdpData?.idp_form_id}))
    }
  },[props.postcoachingData])

  useEffect(()=>{    
    let selecedCoaching = []
    props.coachingData?.coaching.map(item => {
      if(item.selected) selecedCoaching.push(item?.id)
    })
  },[props.coachingData?.coaching])

  const [isDisabled, setIsDisabled] = useState({})
  useEffect(()=>{
    let coaching = values?.coaching_prefer?.length >=4?true:false
    let coaching_location = values?.coaching_location?.length >=2?true:false
    setIsDisabled({
      coaching,
      coaching_location
    })
  },[values])

  return (
    <>
      {!!isFormSubmit && <ThankYou destinationUrl={destination} />}
      {(!!isLoading || !isCollegeData) && <Loader/> }

      <form onSubmit={handleSubmit}>
        {!!DEGREE?.length && (
          <div className="idp_medical_card">
            <h2 className="card_medicine_heading">
            Please select the degree you would want to pursue
            <span>*</span>
            </h2>
            <div className="input_group_wrapper col_1">
              {DEGREE?.map((degree, ind) => (
                <div className="idp_medical_input_group" key={ind}>
                  <input
                    type="radio"
                    value={degree.value}
                    onChange={(e) => {
                      formData(e, handleChange, "degree", values);
                      parseAndHandleChange(e, setFieldValue, 'degree')
                    }}
                    name="degree"
                    className="checkbox"
                    id={`degree-${ind}`}
                    checked={degreeTarget == degree.value ? true : false}
                  />
                  <label htmlFor={`degree-${ind}`}>{degree.label}</label>
                </div>
              ))}
            </div>
            <div className="idp_info_strip">
              <img src={require("../../assets/images/info.png")} alt="" />
              Select your dream path you would want to pursue.
            </div>
          </div>
        )}

        {!!props.coachingModeData?.coaching_mode?.length && 
        [1,3].includes(degreeTarget) &&
          <div className="idp_medical_card">
            <h2 className="card_medicine_heading">Are you interested in coaching? Which mode would you prefer?<span>*</span></h2>
            <div className="idp_radio_blk">
              { 
                props.coachingModeData?.coaching_mode.map((option, ind) => {
                  return ( 
                    <div className="idp_radio_group" key={ind}>
                        <input type="radio"
                            onChange={(e) => {
                              formData(e, handleChange, "coaching_mode", values);
                              parseAndHandleChange(e, setFieldValue, 'coaching_mode')
                            }}
                            name={'coaching_mode'}
                            id={`${'coaching_mode'}-${ind}`} 
                            defaultChecked={option.selected}
                            value={option.id}>
                        </input>
                        <label htmlFor={`${'coaching_mode'}-${ind}`} name={'coaching_mode'}>{option.value}</label>
                    </div>
                )})}
            </div>
            <div className="idp_info_strip">
                <img src={require("../../assets/images/info.png")} alt="" />
                We will guide you to coaching institutions that may be beneficial for you.
            </div>
          </div>
        }
{/* {console.log(props.coachingLocation,'coachingMode',coachingMode,props.coachingData)} */}
      {!!props.coachingData?.coaching?.length &&
        coachingMode == 2 &&
        [1,3].includes(degreeTarget) &&
          <div className="idp_medical_card">
          <h2 className="card_medicine_heading">
          {coachingMode == 1 ? 
            "The following coaching institutions offer online preparation courses." 
            : coachingMode == 2 ?  
              "Based on your location preference, the following coaching institutions offer preparation courses." 
              : 
              'These coaching institutions help your preparation. Select your preferred coaching.'
            }
            <span>*</span>
          </h2>
          
          <div className="input_group_wrapper">
            {props.coachingData?.coaching?.map((coaching, ind, arr) => ind < 3 &&(
              <div className="idp_medical_input_group" key={ind}>
                <input
                  ref={(ele)=> {coachingRef.current[ind] = ele}}
                  type="checkbox"
                  onChange={(e) => {
                    formData(e, handleChange, "coaching_prefer");
                  }}
                  disabled={isDisabled?.coaching && !values?.coaching_prefer?.includes(`${coaching.id}`) ? true : false}
                  className="checkbox"
                  name="coaching_prefer"
                  id={`coaching-list-${ind}`}
                  defaultChecked={coaching.selected}
                  value={coaching.id}
                />
                <label
                className={isDisabled?.coaching && !values?.coaching_prefer?.includes(`${coaching.id}`) ? 'is_disabled' : ''}
                 htmlFor={`coaching-list-${ind}`}>{coaching.name}</label>
              </div>
            ))}
            
            {props.coachingData?.coaching?.length >= 4 &&
              <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Coaching Institutes"
                name="coaching_prefer"
                isMulti
                isClearable={false}
                isSearchable={true}
                isOptionDisabled={() => values?.coaching_prefer?.length >= 4}
                options={props.coachingData?.coaching.slice(3)}
                defaultValue={filterCoaching(
                  props.coachingData?.coaching.slice(3)
                )}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                onChange={(obj, actionMeta) =>
                  handleCoaching(obj, actionMeta,'coaching_prefer')
                }
              />
            }
          </div>
          <div className="idp_info_strip">
            <img src={require("../../assets/images/info.png")} alt="" />
            You can select up to 4 institutions
          </div>
        </div>
        }

        {!!props.coachingLocation?.value?.length && coachingMode == 2 &&
        [1,3].includes(degreeTarget) &&
          <div className="idp_medical_card">
            <h2 className="card_medicine_heading">
            Please select your preferred location for coaching
              <span>*</span>
            </h2>
            <div className="input_group_wrapper">
              {props.coachingLocation?.value?.map((item, ind) => ind < 8 && (
                <div className="idp_medical_input_group" key={ind}>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      formData(e, handleChange, "coaching_location");
                    }}
                    disabled={isDisabled?.coaching_location && !values?.coaching_location?.includes(`${item.id}`) ? true : false}
                    className="checkbox"
                    name="coaching_location"
                    id={`coaching_location-${ind}`}
                    defaultChecked={item.selected}
                    value={item.id}
                  />
                  <label
                    className={isDisabled?.coaching_location && !values?.coaching_location?.includes(`${item.id}`) ? 'is_disabled' : ''}
                    htmlFor={`coaching_location-${ind}`}>{item.name}</label>
                </div>
              ))}

              {props.coachingLocation?.value?.length >= 9 &&
              <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Coaching Institutes"
                name="coaching_location"
                isMulti
                isClearable={false}
                isSearchable={true}
                isOptionDisabled={() => values?.coaching_location?.length >= 2}
                options={props.coachingLocation?.value.slice(8)}
                defaultValue={filterCoaching(
                  props.coachingLocation?.value.slice(8)
                )}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                onChange={(obj, actionMeta) =>
                  handleCoaching(obj, actionMeta,'coaching_location')
                }
              />
              }
              <div className="idp_info_strip">
                  <img src={require("../../assets/images/info.png")} alt="" />
                  You can select up to 2 location
              </div>
            </div>
          </div>
        }



        {/* {!!props.coachingListData?.coaching_data?.length &&
        [1,3].includes(degreeTarget) &&
          <div className="idp_medical_card">
          <h2 className="card_medicine_heading">
            Please select your preferred coaching institute
            <span>*</span>
          </h2>
          <div className="input_group_wrapper">
            {props.coachingListData?.coaching_data?.map((coaching, ind) => (
              <div className="idp_medical_input_group" key={ind}>
                <input
                  ref={(ele)=> {coachingRef.current[ind] = ele}}
                  type="checkbox"
                  onChange={(e) => {
                    formData(e, handleChange, "coaching_prefer");
                  }}
                  className="checkbox"
                  name="coaching_prefer"
                  id={`coaching-list-${ind}`}
                  defaultChecked={coaching.status == 1 ? true : false}
                  value={coaching.id}
                />
                <label htmlFor={`coaching-list-${ind}`}>{coaching.name}</label>
              </div>
            ))}
          </div>
          <div className="idp_info_strip">
            <img src={require("../../assets/images/info.png")} alt="" />
            Through this information we’ll be able to guide you the coaching that suits you the best for your NEET Preparation
          </div>
        </div>
        } */}

        {[1, 3].includes(degreeTarget) &&
          !!FREE_COUNSELLING?.length && (
          <div className="idp_medical_card">
            <h2 className="card_medicine_heading">
              Would you want to attend free counseling sessions that help in your MBBS admission?
              <span>*</span>
            </h2>
            <div className="idp_radio_blk">
              {FREE_COUNSELLING?.map((item, ind) => (
                <div className="idp_radio_group" key={ind}>
                  <input
                    type="radio"
                    value={item.id}
                    onChange={(e) => {
                      formData(e, handleChange, "free_counselling");
                    }}
                    className={`checkbox ${
                      values?.free_counselling == item.id ? "checked" : ""
                    }`}
                    name="free_counselling"
                    data-id={item.value}
                    id={`counselling-${ind}`}
                    defaultChecked={freeCounselling == item.id ? true : false}
                  />
                  <label htmlFor={`counselling-${ind}`}>{item.label}</label>
                </div>
              ))}
            </div>
            <div className="idp_info_strip">
              <img src={require("../../assets/images/info.png")} alt="" />
              Get guidance through free counseling sessions exclusively developed by our career experts and clear all your doubts
            </div>
          </div>
        )}

        {[1, 3].includes(degreeTarget) &&
        !!ONE_TO_ONE_COUNSELLING?.length && (
          <div className="idp_medical_card">
            <h2 className="card_medicine_heading">
              Would you buy a 'Careers360 One to One Counseling' service and make your MBBS admission journey smoother?
              <span>*</span>
            </h2>
            <div className="idp_radio_blk">
              {ONE_TO_ONE_COUNSELLING?.map((item, ind) => (
                <div className="idp_radio_group" key={ind}>
                  <input
                    type="radio"
                    value={item.id}
                    onChange={(e) => {
                      formData(e, handleChange, "buy_counselling");
                    }}
                    className={`checkbox ${
                      values?.buy_counselling == item.id ? "checked" : ""
                    }`}
                    name="buy_counselling"
                    data-id={item.value}
                    id={`buy-counselling-${ind}`}
                    defaultChecked={buyCounselling == item.id ? true : false}
                  />
                  <label htmlFor={`buy-counselling-${ind}`}>
                    {item.label}
                  </label>
                </div>
              ))}
            </div>
            <div className="idp_info_strip">
              <img src={require("../../assets/images/info.png")} alt="" />
              Get college insights such as fee, cutoff, bond, hospital infrastructure, choice filling etc and make your admissions smoother.
            </div>
          </div>
        )}

        {!!props.examData?.exams?.length &&
          [1, 2, 3].includes(degreeTarget) && (
            <div className="idp_medical_card">
              <h2 className="card_medicine_heading">Select Target Exams <span>*</span></h2>
              <div className="input_group_wrapper">
                {props.examData?.exams?.map((exam, ind) => (
                  <div className="idp_medical_input_group" key={ind}>
                    <input
                      type="checkbox"
                      value={exam?.id}
                      disabled={([1, 3].includes(degreeTarget) && exam?.id == 789) ? true : false}
                      // checked={!exam?.hasOwnProperty("status") && true}
                      onChange={(e) => {
                        formData(e, handleChange, "target_exam", values);
                      }}  
                      className="checkbox"
                      name="target_exam"
                      id={`exam-${ind}`}
                      defaultChecked={exam?.status == 1 ? true : false}
                    />
                    <label htmlFor={`exam-${ind}`} className={`${([1, 3].includes(degreeTarget) && exam?.id == 789) ? 'checkbox_preselected':''}`}>
                      {exam?.exam_short_name
                        ? exam?.exam_short_name
                        : exam?.exam_name}
                    </label>
                  </div>
                ))}
              </div>
              <div className="idp_info_strip">
                <img src={require("../../assets/images/info.png")} alt="" />
                The choice of exam depends on the degree and specialization you seek to pursue.
              </div>
            </div>
          )}

          {!!props.specializationsData?.specializations?.length &&
          [2,3].includes(degreeTarget) && (
            <div className="idp_medical_card">
              <h2 className="card_medicine_heading">
                What are the specializations that you’re interested in?
                <span>*</span>
              </h2>
              <div className="input_group_wrapper">
                {props.specializationsData?.specializations?.map(
                  (spec, ind) =>
                    ind < 8 && (
                      <div className="idp_medical_input_group" key={ind}>
                        <input
                          type="checkbox"
                          value={spec?.id}
                          onChange={(e) => {
                            formData(e, handleChange, "specializations");
                          }}
                          className="checkbox"
                          name="specializations"
                          id={`specilization-${ind}`}
                          defaultChecked={spec.status == 1 ? true : false}
                        />
                        <label htmlFor={`specilization-${ind}`}>
                          {spec?.name}
                        </label>
                      </div>
                    )
                )}

                {props.specializationsData?.specializations?.length > 8 && (
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    name="specializations"
                    isMulti
                    isClearable={false}
                    isSearchable={true}
                    options={
                      props.specializationsData?.specializations
                        ? props.specializationsData?.specializations?.slice(8)
                        : []
                    }
                    defaultValue={filterSpecilization(
                      props.specializationsData?.specializations?.slice(8)
                    )}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    onChange={(obj, actionMeta) =>
                      handleSpecializations(obj, actionMeta)
                    }
                  />
                )}
              </div>
              <div className="idp_info_strip">
                <img src={require("../../assets/images/info.png")} alt="" />
                Know all about the types of specializations offered by colleges / universities in your selected field of medicine
              </div>
            </div>
          )}

          {!!PREFERED_LOCATION.length && [1,2,3].includes(degreeTarget) && (
            <div className="idp_medical_card"> 
              <h2 className="card_medicine_heading">
                Mention preferred location
                <span>*</span>
              </h2>
              <div className="idp_radio_blk column">
                {PREFERED_LOCATION?.map((location, ind) => (
                  <div className="idp_radio_group" key={ind}>
                    <input
                      type="radio"
                      value={location.value}
                      onChange={(e) => {
                        formData(e, handleChange, "prefered_location");
                      }}
                      className="checkbox"
                      name="prefered_location"
                      id={`location-${ind}`}
                      checked={preferLocation == location.value ? true : false}
                    />
                    <label htmlFor={`location-${ind}`}>{location.label}</label>
                  </div>
                ))}
              </div>
              <div className="idp_info_strip">
                <img src={require("../../assets/images/info.png")} alt="" />
                There are a number of factors such as fee, cut off, etc that impacts your preferred location to study.
              </div>
            </div>
          )}

      {!!PREFERED_COLLEGE.length &&
        [1, 3].includes(degreeTarget) && (
          <div className="idp_medical_card">
            <h2 className="card_medicine_heading">
              Choose your preferred college / university
              <span>*</span>
            </h2>
            <div className="input_group_wrapper display_block">
              {PREFERED_COLLEGE?.map((college, ind) => (
                <div className="idp_medical_input_group" key={ind}>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      formData(e, handleChange, "prefered_college");
                    }}
                    className="checkbox"
                    name={`prefered_college`}
                    id={`college-${ind}`}
                    checked={
                      values?.prefered_college?.includes(college?.value) ? true : false
                    }
                    value={college.value}
                  />
                  <label htmlFor={`college-${ind}`}>{college.label}</label>
                  {/* <span className="infotip_blk">
                    <img src={require("../../assets/images/info.png")} alt="" />
                    <div className="infotip">
                      <strong>Private colleges NEET Rank range</strong>
                      <table>
                        <thead>
                          <tr>
                            <th>College Rank</th>
                            <th>GN</th>
                            <th>OBC</th>
                            <th>SC</th>
                            <th>ST</th>
                          </tr>
                        </thead>
                        <tbody>
                          
                          {college?.cutoff?.map((item, ind)=>(
                            <tr key={ind}>
                              <td>{item.rank}</td>
                              <td>{item.gn}</td>
                              <td>{item.obc}</td>
                              <td>{item.sc}</td>
                              <td>{item.st}</td>
                            </tr>
                          ))}
                          
                        </tbody>
                      </table>
                      <strong>Fees:</strong> Upto {college.fee}
                    </div>
                  </span> */}
                </div>
              ))}
            </div>
          </div>
        )}

        

          {!!props.otherSpecializationData?.branches?.length &&
          [1].includes(degreeTarget) &&
          !!values?.enrollment && (
            <div className="idp_medical_card">
              <h2 className="card_medicine_heading">
                As an option, Would you consider the following allied Science Degrees apart from MBBS/BDS (if any)
              </h2>
              <div className="input_group_wrapper display_block">
                {props.otherSpecializationData?.branches?.map(
                  (branch, ind) =>
                    ind < 8 && (
                      <div className="idp_medical_input_group" key={ind}>
                        <input
                          type="checkbox"
                          value={branch.id}
                          onChange={(e) => {
                            formData(e, handleChange, "other_specializations");
                          }}
                          name="other_specializations"
                          className="checkbox"
                          id={`branch-${ind}`}
                          defaultChecked={branch.status == 1 ? true : false}
                        />
                        <label htmlFor={`branch-${ind}`}>{branch.name}</label>
                        <span className="offered">
                          <img
                            src={require("../../assets/images/home.png")}
                            alt=""
                          />{" "}
                          {branch.college_count} Colleges
                        </span>
                      </div>
                    )
                )}
              </div>
              {props.otherSpecializationData?.branches?.length > 8 && (
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  name="other_specializations"
                  isMulti
                  isClearable={false}
                  isSearchable={true}
                  options={
                    props.otherSpecializationData?.branches
                      ? props.otherSpecializationData?.branches?.slice(8)
                      : []
                  }
                  defaultValue={otherFilterSpecilization(
                    props.otherSpecializationData?.branches?.slice(8)
                  )}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  onChange={(obj, actionMeta) =>{
                    handleOtherSpecializations(obj, actionMeta)
                  }}
                />
              )}
              <div className="idp_info_strip">
                <img src={require("../../assets/images/info.png")} alt="" />
                Apart from MBBS / BDS there are numerous career paths you can pursue in the field of medicine.
              </div>
            </div>
          )}

          {!!props.topCollegesData?.colleges?.length && isCollegeData &&
            [2, 3].includes(degreeTarget) && (
            <div className="idp_medical_card">
              <h2 className="card_medicine_heading">
                The following top private colleges / universities provide medical & allied courses. Select all colleges/universities, you would like to know more about. 
                <span>*</span>
              </h2>
              <div className="input_group_wrapper">
                {props.topCollegesData?.colleges?.map(
                  (college, ind) =>
                    ind < 8 && (
                      <div className="idp_medical_input_group" key={ind}>
                        <input
                          type="checkbox"
                          value={college.id}
                          onChange={(e) => {
                            formData(e, handleChange, "top_private_college");
                          }}
                          name="top_private_college"
                          className="checkbox"
                          id={`top_private_college-${ind}`}
                          defaultChecked={college.status == 1 ? true : false}
                        />
                        <label htmlFor={`top_private_college-${ind}`}>
                          {college.name}
                        </label>
                      </div>
                    )
                )}
              </div>
            </div>
          )}

        <div className="user_guide">This is a quick form designed to understand your needs and help you in your preparation and getting into the right medical university. </div>
       
        <div className="idp_medicine_btn_Submit">
          <input
            type="submit"
            name="next"
            className="action-button btn"
            value="Submit your preferences"
            disabled={
              // isValid == false
              (
                (//!!props.coachingData?.coaching?.length
                  ([1].includes(degreeTarget) || [1].includes(values.degree)) && 
                  ((!!props.coachingData?.coaching?.length && [1,2]?.includes(coachingMode)) ? !!values.coaching_prefer?.length : true) && 
                  (coachingMode && [1,2,3]?.includes(coachingMode))&&
                  (
                    (!!props.coachingLocation?.value?.length && [2]?.includes(coachingMode)) ? !!values?.coaching_location?.length : true
                  ) &&
                  ([0,1].includes(freeCounselling) || ['0','1'].includes(values.free_counselling)) && 
                  ([0,1].includes(buyCounselling) || ['0','1'].includes(values.buy_counselling)) &&
                  ([1,2, 3].includes(preferLocation) || ['1','2', '3'].includes(preferLocation)) &&
                  !!values?.prefered_college?.length
                )
                  ||
                (
                  ([2].includes(degreeTarget) || [2].includes(values.degree)) && 
                  !!props.examData?.exams?.length && !!values?.target_exam?.length &&
                  ([1,2, 3].includes(preferLocation) || ['1','2', '3'].includes(preferLocation)) &&
                  (!!values?.specializations?.length || !!values?.specializations_select?.length) &&
                  (props.topCollegesData?.colleges?.length == 0 || values?.top_private_college?.length)
                )
                ||
                (
                  ([3].includes(degreeTarget) || [3].includes(values.degree)) &&
                  ((!!props.coachingData?.coaching?.length && [1,2]?.includes(coachingMode)) ? !!values.coaching_prefer?.length : true) && 
                  (coachingMode && [1,2,3]?.includes(coachingMode))&&
                  (
                    (!!props.coachingLocation?.value?.length && [2]?.includes(coachingMode)) ? !!values?.coaching_location?.length : true
                  ) &&
                  ([0,1].includes(freeCounselling) || ['0','1'].includes(values.free_counselling)) && 
                  ([0,1].includes(buyCounselling) || ['0','1'].includes(values.buy_counselling)) &&
                  !!props.examData?.exams?.length && !!values?.target_exam?.length &&
                  ([1,2,3].includes(preferLocation) || ['1','2', '3'].includes(preferLocation)) &&
                  !!values?.prefered_college?.length &&
                  (!!values?.specializations?.length || !!values?.specializations_select?.length) &&
                  (props.topCollegesData?.colleges?.length == 0 || values?.top_private_college?.length)
                )
              )
                ? false
                : true
            }
          />
        </div>
      </form>
    </>
  );
};



const mapStateToProps = (state) => {
  return {
    user: state.userData?.user,
    isUser: state.userData,
    getIdpData: state.idp?.getIdpSuccess?.data,
    formStatusData: state.ipdMedical?.medicalFormStatusSuccess?.data,
    idpStatusData: state.ipdMedical?.medicalIdpStatusSuccess?.data,
    degreeData: state.ipdMedical?.medicalDegreeSuccess?.data,
    examData: state.ipdMedical?.medicalExamSuccess?.data,
    specializationsData: state.ipdMedical?.medicalSpecializationSuccess?.data,
    coachingData: state.ipdMedical?.medicalCoachingSuccess?.data,
    postcoachingData: state.ipdMedical?.postMedicalCoachingSuccess,
    coachingLocation: state.ipdMedical?.medicalCoachingLocationSuccess?.data,
    coachingListData: state.ipdMedical?.medicalCoachingListSuccess?.data,
    coachingModeData: state.ipdMedical?.medicalCoachingModeSuccess?.data,
    locationData: state.ipdMedical?.medicalPreferLocationSuccess?.data,
    preferedCollegeData: state.ipdMedical?.medicalPreferCollegeSuccess?.data,
    otherSpecializationData:
      state.ipdMedical?.medicalOtherSpecializationSuccess?.data,
    topCollegesData: state.ipdMedical?.medicalTopCollegesSuccess?.data,
    productData: state.ipdMedical?.medicalProductsSuccess?.data,
    productOneToOneData: state.ipdMedical?.medicalProductsOneToOneSuccess?.data,
    productEnrollmentData:
      state.ipdMedical?.medicalProductsEnrollmentSuccess?.data,
    formSubmitData: state.ipdMedical?.postMedicalFormSubmitSuccess?.data,
  };
};  

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicineForm);
